import React from 'react';

import * as S from './styles';
import {
  DocumentProps,
  PdfPageStateProps,
  PDFViewerRef,
} from 'components/ListDocumentsViewer/utils/interfaces';
import {
  Add,
  Close,
  DeleteOutline,
  Refresh,
  Remove,
  SaveAlt,
  Menu,
} from '@material-ui/icons';
import { Divider, Tooltip, Typography } from '@material-ui/core';

interface HeaderProps {
  onClose: () => void;
  pdfViewerRef: React.RefObject<PDFViewerRef>;
  title: string;
  handleClickButtonDelete?: ({ documentId }: { documentId: number }) => void;
  isLoading?: boolean;
  pdfRender?: DocumentProps;
  listDocumentsViewerState: PdfPageStateProps;
  setListDocumentsViewerState: React.Dispatch<
    React.SetStateAction<PdfPageStateProps>
  >;
  handleShowSidebar: () => void;
  hideSidebar: boolean;
}

export const Header = ({
  onClose,
  pdfViewerRef,
  title,
  handleClickButtonDelete,
  isLoading = false,
  pdfRender,
  listDocumentsViewerState,
  setListDocumentsViewerState,
  handleShowSidebar,
  hideSidebar,
}: HeaderProps) => {
  const handleDownload = () => {
    setListDocumentsViewerState(prev => ({
      ...prev,
      downloadClicked: !listDocumentsViewerState?.downloadClicked,
    }));
  };

  const convertScaleForPercentage = (scale: number) => {
    return `${Math.round(scale * 100)}%`;
  };

  const clickButtonDelete = () => {
    const documentId = pdfRender?.id;
    if (documentId) handleClickButtonDelete?.({ documentId });
  };

  return (
    <S.Container>
      {isLoading || !title?.length ? (
        <S.SkeletonCustom variant="text" />
      ) : (
        <Tooltip
          title={hideSidebar ? 'Abrir Sidebar' : 'Fechar Sidebar'}
          placement="bottom-start"
        >
          <S.TitleSection>
            <S.CustomIconButton
              customType="icon"
              variant="text"
              onClick={handleShowSidebar}
              fontSize="20px"
            >
              <Menu />
            </S.CustomIconButton>

            <S.Title variant="h6">{title}</S.Title>
          </S.TitleSection>
        </Tooltip>
      )}

      <S.ActionsContainer>
        <S.ContainerZoom>
          <S.TextZoom>
            {convertScaleForPercentage(listDocumentsViewerState?.scale ?? 1)}
          </S.TextZoom>

          <S.CustomIconButton
            customType="icon"
            variant="text"
            onClick={() => pdfViewerRef?.current?.zoomOut()}
            fontSize="16px"
            disabled={!!listDocumentsViewerState?.downloadClicked}
          >
            <Remove />
          </S.CustomIconButton>

          <Divider orientation="vertical" flexItem />

          <S.CustomIconButton
            customType="icon"
            variant="text"
            onClick={() => pdfViewerRef?.current?.zoomIn()}
            fontSize="16px"
            disabled={!!listDocumentsViewerState?.downloadClicked}
          >
            <Add />
          </S.CustomIconButton>
        </S.ContainerZoom>

        <S.PageIndicatorWrapper>
          <Divider orientation="vertical" flexItem />

          <Typography variant="body1">
            {`${listDocumentsViewerState?.currentDocumentIndex}/${listDocumentsViewerState?.totalDocuments}`}
          </Typography>

          <Divider orientation="vertical" flexItem />
        </S.PageIndicatorWrapper>

        <Tooltip title="Girar documento" placement="bottom">
          <S.CustomIconButton
            customType="icon"
            variant="text"
            onClick={() => pdfViewerRef?.current?.rotateClockwise()}
            disabled={!!listDocumentsViewerState?.downloadClicked}
          >
            <Refresh color="inherit" />
          </S.CustomIconButton>
        </Tooltip>

        <Tooltip title="Baixar documento" placement="bottom">
          <S.CustomIconButton
            customType="icon"
            variant="text"
            data-active={!!listDocumentsViewerState?.downloadClicked}
            onClick={handleDownload}
          >
            <SaveAlt color="inherit" />
          </S.CustomIconButton>
        </Tooltip>

        <Tooltip title="Excluir documento" placement="bottom">
          <S.CustomIconButton
            customType="icon"
            variant="text"
            onClick={clickButtonDelete}
            disabled={!!listDocumentsViewerState?.downloadClicked}
          >
            <DeleteOutline color="inherit" />
          </S.CustomIconButton>
        </Tooltip>
      </S.ActionsContainer>

      <Tooltip title="Fechar" placement="bottom-end">
        <S.RightActions>
          <S.CustomIconButton
            customType="icon"
            variant="text"
            onClick={onClose}
          >
            <Close color="inherit" />
          </S.CustomIconButton>
        </S.RightActions>
      </Tooltip>
    </S.Container>
  );
};
